import React, { useState } from 'react';
import { linkifyText, asText } from '../lib/sanitize';
import { COLORS, SPACING } from '../styles/theme';

interface ExternalLinkProps {
  href: string;
  children?: React.ReactNode;
}

export function ExternalLink({ href, children }: ExternalLinkProps) {
  const [confirmed, setConfirmed] = useState(false);

  let domain = '';
  try {
    domain = new URL(href).hostname;
  } catch {
    return null;
  }

  if (!confirmed) {
    return (
      <span
        onClick={() => setConfirmed(true)}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 4,
          border: `1px solid ${COLORS.border}`,
          padding: `1px ${SPACING.xs}`,
          cursor: 'pointer',
          fontFamily: 'monospace',
          fontSize: '11px',
          color: COLORS.textMuted,
        }}
        title={`Tap to load from ${domain}`}
      >
        ⚠ {domain} — tap to load
      </span>
    );
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: COLORS.accent, fontFamily: 'monospace', fontSize: '12px' }}
    >
      {children || href}
    </a>
  );
}

export function renderContent(text: string): React.ReactNode[] {
  return linkifyText(asText(text)).map((part, i) =>
    part.type === 'url'
      ? <ExternalLink key={i} href={part.content} />
      : <span key={i}>{part.content}</span>
  );
}
